<div class="main-wrapper">
  <span class="header1" *ngIf="projectName.length > 0">{{ 'ProjectSelectedProject' | t }}</span>
  <div class="field-wrapper" *ngIf="projectName.length > 0">
    <span class="label">{{ 'ProjectWizardSubViewOverviewProjectName' | t }}</span>
    <span class="fieldval">{{ projectName }}</span>
  </div>
  <div class="system-wrapper" *ngIf="projectName.length > 0">
    <span class="label">{{ 'ProjectSystem' | t }}</span>
    <span class="fieldval">{{
      this.projectService.isMetricUnit ? "Metirc" : "Imperial"
    }}</span>
  </div>
  <div class="lang-wrapper" *ngIf="projectName.length > 0">
    <span class="label">{{ 'SettingsLanguage' | t }}</span>
    <span class="fieldval">{{ this.projectService.selectedLang }}</span>
  </div>

  <span class="header2">{{ 'ProjectProjectUpload' | t }}</span>
  <div class="system">
    <span class="label">{{ 'ProjectSystem' | t }}</span>
    <input
      type="radio"
      id="met"
      name="sys"
      [value]="true"
      [(ngModel)]="this.projectService.toUpload_isMetricUnit"
    />
    <label for="age1">{{ 'ProjectMetirc' | t }}</label><br />
    <input
      type="radio"
      id="imp"
      name="sys"
      [value]="false"
      [(ngModel)]="this.projectService.toUpload_isMetricUnit"
    />
    <label for="age2">{{ 'SettingsImperial' | t }}</label><br />
  </div>
  <button (click)="onFileInput()">
    {{ file ? file.name : "Upload Zip" }}
  </button>
</div>
